import { render, staticRenderFns } from "./FinalExamKioskIndex.vue?vue&type=template&id=43f855f2"
import script from "./FinalExamKioskIndex.vue?vue&type=script&lang=js"
export * from "./FinalExamKioskIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports